<template>
  <div id="Header">
    <div class="header_line">
      <div class="header_top">
        <div class="login_or_register" v-if="islogin==null">
          <router-link class="lr_btn" :to="{path:'/login'}">{{$t('base.login')}}</router-link>
          {{$t('base.or')}}
          <router-link class="lr_btn" :to="{path:'/register'}">{{$t('base.register')}}</router-link>
        </div>
        <div class="card_hobby_header card_hobby_login" v-if="islogin!=null" :class="logout?'on':''" @click="clickAboutCardhobby(2)">
          <div class="header_text user_header">
            <el-avatar class="user_header_icon" icon="el-icon-user-solid" :src="islogin.HeadPortrait"></el-avatar>{{islogin.NickName}}
          </div>
          <div class="h_box logout_box" v-if="logout" @mouseleave="logout=false">
            <div class="logout_box_logo">
              <img :src="islogin.HeadPortrait!='没有可上传的图片'?islogin.HeadPortrait+'?imageView2/2/w/100':'../static/images/noimg.svg'">
              <div class="nickname">{{islogin.NickName}}</div>
              <router-link class="chp" :to="{path:'/mycardhobby/chp'}">{{islogin.SumMoney}}</router-link>
            </div>
            <ul class="login_list">
              <li>
                <router-link :to="{path:'/mycardhobby/setting'}">{{$t('base.accountSettings')}}</router-link>
              </li>
              <li><span @click="Logout">{{$t('base.signOut')}}</span></li>
            </ul>
          </div>
        </div>
        <ul class="header_ul">
          <!-- language -->
          <li class="card_hobby_header" :class="isLanguage?'on':''" @click="clickAboutCardhobby('language')">
            <div class="header_Nav language_text">{{setLanguage('text')}}</div>
            <div id="Language" class="h_box header_Nav_box cardhoddy_box" v-if="isLanguage" @mouseleave="isLanguage=false">
              <ul class="my_card_hoddy languageUl">
                <li v-for="(item,index) in langs" :key="index" @click="setLanguage(item)">{{item.label}}</li>
              </ul>
            </div>
          </li>
          <!-- watchlist -->
          <li class="watch_list_header" :class="isWatchlist?'on':''" @click="getWatchlist()">
            <div class="header_text header_Nav header_watch">{{$t('base.watchList')}}</div>
            <div id="WatchList" class="h_box header_Nav_box  header_watch_list" :class="watchClass" v-if="isWatchlist" @mouseleave="isWatchlist=false" v-loading="loading">
              <div v-if="islogin!=null">
                <div class="header_watch_list_null" v-if="list.length<1">{{$t('alert.lookItemYet')}}</div>
                <router-link :to="{path:'/mycardhobby/watch'}" class="list_title_a" @click="isWatchlist=false" v-if="list.length>0">{{$t('base.viewAllItem')}}</router-link>
                <header-watch class="header_watch_list_box" :list="list" v-if="list.length>0" />
              </div>
              <div class="user_no" v-else>{{$t('base.please')}} <router-link :to="{path:'/login'}" class="text_blue">{{$t('base.login')}}</router-link> {{$t('base.viewAllItem')}}</div>
            </div>
          </li>
          <!-- MyCardHobby -->
          <li class="card_hobby_header" :class="MyCardHobby?'on':''" @click="clickAboutCardhobby(1)">
            <div class="header_text header_Nav">{{$t('base.myCardHobby')}}</div>
            <div id="MyCardHobby" class="h_box header_Nav_box cardhoddy_box" v-if="MyCardHobby" @mouseleave="MyCardHobby=false">
              <ul class="my_card_hoddy">
                <li :class="(path[0]=='mycardhobby'&&path[1]=='recently')?'on':''">
                  <router-link :to="{path:'/mycardhobby/recently'}">{{$t('base.recentlyViewed')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='bids')?'on':''">
                  <router-link :to="{path:'/mycardhobby/bids'}">{{$t('base.bidsOffers')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='purchase')?'on':''">
                  <router-link :to="{path:'/mycardhobby/purchase'}">{{$t('base.purchaseHistory')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='mallorder')?'on':''">
                  <router-link :to="{path:'/mycardhobby/mallorder'}">{{$t('base.mallOrders')}}</router-link>
                </li>
                <!-- <li :class="(path[0]=='mycardhobby'&&path[1]=='watch')?'on':''">
                  <router-link :to="{path:'/mycardhobby/watch'}">Watchlist</router-link>
                </li> -->
                <li :class="(path[0]=='mycardhobby'&&path[1]=='warehouse')?'on':''">
                  <router-link :to="{path:'/mycardhobby/warehouse'}">{{$t('base.overseaWarehouse')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='sellers')?'on':''">
                  <router-link :to="{path:'/mycardhobby/sellers'}">{{$t('base.savedSellers')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='search')?'on':''">
                  <router-link :to="{path:'/mycardhobby/search'}">{{$t('title.savedSearches')}}</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='coupons')?'on':''">
                  <router-link :to="{path:'/mycardhobby/coupons'}">{{$t('base.myCoupons')}}</router-link>
                </li>
                  <li v-if="islogin!=null&&islogin.MemberSource=='US'" :class="(path[0]=='mycardhobby'&&path[1]=='taxrefund')?'on':''">
                  <router-link :to="{path:'/mycardhobby/taxrefund'}">{{$t('title.taxrefund')}}</router-link>
                </li>
                <!-- <li :class="(path[0]=='mycardhobby'&&path[1]=='setting')?'on':''">
                  <router-link :to="{path:'/mycardhobby/setting'}">Account Settings</router-link>
                </li>
                <li :class="(path[0]=='mycardhobby'&&path[1]=='chp')?'on':''">
                  <router-link :to="{path:'/mycardhobby/chp'}">My CHP</router-link>
                </li> -->
                <!-- <li :class="(path[0]=='messages')?'on':''">
                  <router-link :to="{path:'/messages'}">Messages</router-link>
                </li> -->
              </ul>
            </div>
          </li>
          <!-- Sell -->
          <li class="card_hobby_header">
            <router-link class="header_text header_sell" :to="{path:'/login'}" v-if="islogin==null">{{$t('base.sell')}}</router-link>
            <div class="header_text header_sell" @click='gotoSell' v-if="islogin!=null">{{$t('base.sell')}}</div>
          </li>
        </ul>
        <div class="header_badge" v-if="islogin!=null">
          <!-- Notifications -->
          <el-badge :value="MsgCount" :max="99" class="badge" v-if="MsgCount>0">
            <router-link :to="{path:'/messages'}"></router-link>
          </el-badge>
          <div class="badge" v-else>
            <router-link :to="{path:'/messages'}"></router-link>
          </div>
          <!-- Shopping cart -->
          <el-badge :value="cartNum" :max="99" class="badge shopping_cart" v-if="cartNum>0">
            <router-link :to="{path:'/pay/cart'}"></router-link>
          </el-badge>
          <div class="badge shopping_cart" v-else>
            <router-link :to="{path:'/pay/cart'}"></router-link>
          </div>
        </div>
        <div class="header_badge" v-else>
          <div class="badge">
            <router-link :to="{path:'/login'}"></router-link>
          </div>
          <div class="badge shopping_cart">
            <router-link :to="{path:'/login'}"></router-link>
          </div>
        </div>
        <!-- Contact US -->
        <div class="header_badge">
          <div class="badge">
            <span class="contactBadge" @click="gotoContact"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="mack" :class="istop?'top0':''" v-if="isWatchlist" @click="isWatchlist = false"></div>
    <div class="header_logo" v-if="isPath">
      <a href="/" class="logo"></a>
      <ul class="header_ul">
        <li class="header_category" :class="isCategory?'on':''" @click="clickAboutCardhobby(3)">
          <div class="header_text shop_by_category">{{$t('base.shopByCategory')}}</div>
          <div class="h_box menu_category" v-if="isCategory" @mouseleave="isCategory=false">
            <div class="menu_category_concert" v-for="(item,index) in Category" :key="index">
              <div class="menu_category_solo">{{$store.state.lang != 'zh-tw'?item.EnName:'交易卡'}}</div>
              <ul class="menu_category_ul">
                <li v-for='(ite,i) in item.children' :key="i">
                  <div class="row_arrow menu_category_duet">
                    {{$store.state.lang != 'zh-tw'?ite.EnName:ite.ChName}}
                  </div>
                  <div class="menu_category_trio">
                    <router-link :to="{path:'/market',query:{type:'category',f:item.id,s:ite.id,t:it.id}}" v-for='(it,j) in ite.children' :key="j">{{$store.state.lang != 'zh-tw'?it.EnName:it.ChName}}</router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li>
          <router-link :to="{path:'/terms/privacy'}" class="header_text help">{{$t('base.contactUsHelp')}}</router-link>
        </li>
      </ul>
      <!--  v-if="wordList!=null&&isword" @mouseleave="isword=false" -->
      <div class="search_input_box">
        <div class="key_word" v-if="wordList!=null&&isword" @mouseleave="isword=false">
          <div class="key_word_recent">
            <div class="key_word_tab">
              <em class="on" v-if="islogin==null">{{$t('base.recent')}}</em>
              <em :class="{'on':!isSave}" @click="isSave=!isSave" v-if="islogin!=null">{{$t('base.recent')}}</em>
              <em :class="{'on':isSave}" @click="isSave=!isSave" v-if="islogin!=null">{{$t('base.saved')}}</em>
            </div>
            <span v-if="!isSave" @click="keyWordDelete"></span>
            <router-link class="seemore" v-if="isSave" :to="{path:'/mycardhobby/search'}">See More</router-link>
          </div>
          <header-saved v-if="isSave" :userInfo='islogin' />
          <div v-if="!isSave" class="key_word_list" v-for="(item,index) in wordList" :key='index'>
            <span @click="gotoList(item)">{{item}}</span>
          </div>
        </div>
        <el-form ref="form" :model="HeaderForm">
          <!-- @focus="" -->
          <el-input class="search_input" ref="searchKeyWord" :placeholder="tabname" v-model="HeaderForm.name" @focus="getKeyWordSearches" @input="getKeyWordSearches" @keyup.enter.native="GoSearch">
            <i slot="prefix" class="el-input__icon search"></i>
            <el-select class="search_sele" slot="append" :placeholder="$t('base.items')" v-model="HeaderFormRegion" @change="chooseSearch">
              <el-option v-for="(item,index) in header_type" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
          <el-button class="search_btn" @click="GoSearch" :disabled="HeaderForm.name?false:true" type="primary">{{$t('base.search')}}</el-button>
        </el-form>
      </div>
    </div>
    <div class="header_title" v-if="!isPath">
      <div class="header_logo">
        <a href="/" class="logo"></a>
        <h1 v-html="headerTitle"></h1>
        <!-- <h1 v-if="this.$route.path.split('/')[2]=='privacy'">Rules and Policies</h1>
        <h1 v-if="this.$route.path.split('/')[2]=='customer'">Customer service</h1>
        <h1 v-if="this.$route.path.split('/')[2]=='account'">Account settings</h1> -->
      </div>
    </div>
  </div>
</template>
<script>
import demo from '@/api/demo'
import HeaderWatch from '@/components/list/headerwatch'
import HeaderSaved from '@/components/list/headersaved'
import { getInfo, resetCategory, toLogout, CookiesCategory } from "@/api/public";
export default {
  name: 'headerNav',
  components: { HeaderWatch, HeaderSaved },
  data() {
    return {
      isSave: false, //是否是保存搜索条件
      KeyWordSearches: 'chyword',
      MyCardHobby: false,
      langs: this.$enumInfo.languages, // ,{ label: "简中", value: "zh" },
      stateLang: this.$store.state.lang,
      logout: false,
      Category: "",
      watchClass: '',
      loading: false,
      header_type: this.$enumInfo.header_type,
      istop: false,
      isCategory: false,
      isWatchlist: false,
      isLanguage: false,
      wordList: null,
      isword: false,
      tab: 1,
      tabname: this.$t('base.pleaseentertosearch'),
      list: '',
      HeaderFormRegion: '1',
      HeaderForm: {
        name: '',
        // region: '1',
      },
      MsgCount: 0,
      islogin: null,
      ishome: false,
      homepath: "",
      cartNum: 0,
      pi: 1,
      ps: 9
    }
  },
  inject: ['reload'],
  props: {
    path: Array,
    headerTitle: String,
    isPath: Boolean,
  },
  mounted() {
    var that = this;
    var searchType = this.$route.name == 'seller' ? '2' : '1';
    that.HeaderFormRegion = searchType;
    this.$root.$on("cardNum", val => {
      //console.log("newSearch", val)
      this.cartNum = val;
    })
    this.$root.$on("isword", val => {
      //console.log("newSearch", val)
      this.isword = val;
    })
    this.$root.$on("newSearch", val => {
      //console.log("newSearch", val)
      this.HeaderForm.name = val;
    })
    let sn = window.localStorage.getItem('sn') != null ? window.localStorage.getItem('sn') : '';
    //console.log("newSearch", sn)
    this.HeaderForm.name = sn
    that.chooseSearch(searchType, 1);
    //console.log("this.HeaderForm.name", this.HeaderForm.name)
    window.addEventListener('scroll', function() {
      if (document.documentElement.scrollTop > 49) {
        that.istop = true
      } else {
        that.istop = false
      }
    })
  },
  created() {
    this.islogin = getInfo();
    if (this.islogin != null) {
      this.getNotificationCount()
      this.getMyCart()
    }
    // console.log('abc',getInfo())
    // console.log('islogin',this.islogin)
    this.setSearchInfo();
    if (this.isPath) {
      let that = this
      let fun = function(res) {
        that.Category = res
      }
      CookiesCategory('get', 'cardCategory', 'shop', fun)
    }
  },
  methods: {
    setLanguage(text) {
      let langs = this.$enumInfo.languages

      let name = this.$store.state.lang
      if (text == 'text') {
        return langs.filter(res => { return res.value == name })[0].label
      } else {
        this.$i18n.locale = text.value;
        this.$store.state.lang = text.value;
        let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.NODE_DOMAIN;
        this.$cookie.set('CardLang', text.value, {
          // expires: this.$store.state.exdays, 
          domain
        });
        this.reload()
      }

    },
    gotoContact() {
      this.$root.$emit("contactUS", true);
    },
    keyWordDelete() {
      let that = this
      let title = 'Delete';
      let msg = `<div class="p_txt">${this.$t('alert.deleteSearchRecords')}</div>`;
      this.$confirm(msg, title, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        lockScroll: false
      }).then(() => {
        window.localStorage.removeItem(that.KeyWordSearches)
      }).catch(() => {});
    },
    clickAboutCardhobby(val, e) {
      // console.log(val)
      this.isWatchlist = false;
      e = e || window.event;
      let isActive = e.currentTarget.getAttribute("class").includes("on");
      if (val == 1) {
        this.MyCardHobby = true
        this.logout = false
        if (isActive) {
          document.getElementsByClassName("card_hobby_header")[0].classList.remove("on");
          this.MyCardHobby = false
        }
      } else if (val == 2) {
        this.logout = true
        this.MyCardHobby = false
        if (isActive) {
          document.getElementsByClassName("card_hobby_header")[0].classList.remove("on");
          this.logout = false
        }
      } else if (val == 3) {
        this.isCategory = true
        if (isActive) {
          document.getElementsByClassName("shop_by_category")[0].classList.remove("on");
          this.isCategory = false
        }
      } else if (val == 'language') {
        this.isLanguage = true
        if (isActive) {
          document.getElementsByClassName("shop_by_category")[0].classList.remove("on");
          this.isLanguage = false
        }
      }
    },
    gotoList(key) {
      this.isword = false;
      this.HeaderForm.name = key
      this.GoSearch()
      // this.$router.push({
      //   path:'/market?type=like&key='+key
      // }).catch(err => err)
    },
    // 跳去卖家端
    gotoSell() {
      let that = this
      if (this.islogin != null) {
        let isSell = this.islogin.IsSeller
        if (isSell) {
          const url = process.env.VUE_APP_SELL_URL
          window.open(url)

        } else {
          // this.$router.push({
          //   path: '/terms/becomeseller'
          // })
          this.$message({
            type: 'error',
            duration: 1000,
            message: that.$enumInfo.error['NOSell']
          });
        }
      } else {

        // this.$router.push({
        //   path: '/terms/becomeseller'
        // })
        this.$message({
          type: 'error',
          duration: 1000,
          message: that.$enumInfo.error['NOSell']
        });
      }
      //console.log(process.env.VUE_APP_SELL_URL)
    },

    //获取购物车个数
    getMyCart() {
      let that = this;
      let data = { BuyerId: this.islogin.MappingUserId, AreaCode: this.islogin.MemberSource, PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetCartList, data).then(res => {
        if (res.Result != 0) {
          let result = res.Data
          if (result.length > 0) {
            let num = 0
            result.map(r => {
              if (r.Num > 0) {
                num++
              }
            })
            that.cartNum = num
          } else {
            that.cartNum = 0
          }
          //that.cartNum=res.data.length
        }
      })
    },
    //获取 Notification 个数
    getNotificationCount() {
      let that = this
      let data = { operator_id: this.islogin.MappingUserId, memberid: this.islogin.MappingUserId, token: this.islogin.ChineseToken }
      this.$get(this.$interface.NotificationCount, data).then(res => {
        if (res.result != 0) {
          this.MsgCount = res.data.TotalCount
        }
      })
    },
    // 关注商品列表
    getWatchlist(e) {
      let that = this;
      that.isWatchlist = true;
      that.loading = true;
      this.MyCardHobby = false
      this.logout = false
      this.isCategory = false
      //判断有无.on
      e = e || window.event;
      let isActive = e.currentTarget.getAttribute("class").includes("on");

      if (isActive) {
        document.getElementsByClassName("watch_list_header")[0].classList.remove("on");
        that.isWatchlist = false;
      }

      if (this.islogin != null) {
        let data = { operator_id: that.islogin.MappingUserId, memberid: that.islogin.MappingUserId, token: that.islogin.ChineseToken, pageIndex: 1, pageSize: 6, ststus: 1, sort: 1, searchtxt: '' }
        this.$get(this.$interface.IsCard, data).then(res => {
          //console.log(res)
          if (res.result != 0) {
            let result = res.data
            if (result.length > 0) {
              if (result.length == 2) {
                that.watchClass = "watchClass2"
              } else if (result.length == 3) {
                that.watchClass = "watchClass3"
              } else if (result.length == 4) {
                that.watchClass = "watchClass4"
              } else if (result.length == 5 || result.length == 6) {
                that.watchClass = "watchClass5"
              } else {
                that.watchClass = ""
              }
              that.list = result;
            }

            that.loading = false;
          } else {
            that.loading = false;
          }
          //console.log(res)
        })
      } else {
        that.loading = false;
      }
      //let data={}
    },
    // 获取模糊搜索
    getKeyWordSearches() {
      let that = this;
      // 获取模糊搜索
      // let data = { 'SearchKey': this.HeaderForm.name, 'PageSize': that.ps, 'PageIndex': that.pi }
      // this.$get(this.$interface.GetKeyWordSearches, data).then(res => {
      //   console.log(res)
      // })
      // 进本地缓存 共20条，新增删除最后一条
      // if(that.HeaderFormRegion==2){
      //   this.KeyWordSearches='chySeller'
      // }
      let wordList = window.localStorage.getItem(this.KeyWordSearches) != null ? window.localStorage.getItem(this.KeyWordSearches) : null;
      that.wordList = JSON.parse(wordList);
      that.isword = true
    },
    //
    setSearchInfo() {
      let that = this;
      let route = this.getRoute();
      if (route[0] == "market" || (route[0] == "seller" && route[1] == "list")) {
        that.HeaderForm.name = window.localStorage.getItem('sn');
        that.HeaderFormRegion = window.localStorage.getItem('st');
      } else {
        window.localStorage.removeItem('sn');
        window.localStorage.removeItem('st');
      }
      if (route[0] == "mycardhobby") {
        this.isWatchlist = false;
      }
      //console.log(route)
    },
    getRoute() {
      let route = this.$route.path.slice(1).split("/");
      return route
    },
    // 跳转对应搜索结果页面 type=>1:商品列表和type=>2:卖家列表
    GoSearch() {
      let that = this;
      let name = that.HeaderForm.name; // key
      if (name) {
        let type = that.HeaderFormRegion; // 状态
        let wordList = window.localStorage.getItem(this.KeyWordSearches) != null ? window.localStorage.getItem(this.KeyWordSearches) : null;
        that.isword = false;
        if (wordList != null) {
          wordList = JSON.parse(wordList);
          let arr1 = JSON.parse(JSON.stringify(wordList))
          arr1.unshift(name)
          arr1.splice(10, arr1.length - 10)
          wordList = new Set(arr1)
        } else {
          wordList = [name]
        }
        let url = "/market?type=like&key=" + name;
        // /seller/list
        let route = this.getRoute();
        if (this.path[0] == 'list') {
          url = "/list/?key=" + name;
        }
        if (type == 2) {
          url = "/seller/list?key=" + name;
        }
        that.$root.$emit("newSearch", name);
        if (name) {
          window.localStorage.setItem("sn", name)
          window.localStorage.setItem("st", type)
          window.localStorage.setItem(that.KeyWordSearches, JSON.stringify(wordList))
        }
        this.$refs.searchKeyWord.blur()
        //console.log()
        this.$router.push({
          path: url,
        }).catch(err => err)
      }
    },
    Logout() {
      window.localStorage.setItem('toa', this.islogin.MappingUserId)
      let path = this.$route.path.slice(1).split("/");
      toLogout('cardUser')
      if (path[0] == "mycardhobby" && (path[1] == "bidhistory" || path[1] == "offerhistory")) {
        this.$router.push({
          path: '/',
        }).catch(err => err)
      }
      this.reload()
    },
    goto() {
      this.isWatchlist = false;
    },
    // type 1:刷新
    chooseSearch(value, type) {
      // if (type != 1) {
      //   this.HeaderForm.name = "";
      // }
      this.isword = false
      this.tabname = value == 1 ? this.$t('base.pleaseentertosearch') : this.$t('base.searchForSeller')
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../../static/css/header.css";

.mack {
  background-color: rgba(51, 51, 51, 0.6);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 49px;
  z-index: 7;
}

.top0 {
  top: 0;
}

.p_txt {
  text-align: center;
}

.language_text {
  background: url(/static/images/icon/icon_earth.svg) no-repeat 10px 50%;
  height: 27px;
  padding-left: 32px;
  font-weight: 700;
  padding-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.language_text:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.languageUl li {
  padding: 5px;
  cursor: pointer;
}

.languageUl li:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue